import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class MdaProvider {
  baseUrl = environment.API_URL;
  baseAntigaUrl = environment.API_ANTIGA_URL;
  constructor(public http: HttpClient) {
    
  }

  getTipoOcorrencia() {
    return this.http.get<any>(this.baseUrl + '/mda/tipo-ocorrencia')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getMda() {
    return this.http.get<any>(this.baseUrl + '/mda')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getPessoaMdaById(idPessoa: string) {
    return this.http.get<any>(this.baseUrl + '/mda/get-by-id-pessoa/' + idPessoa)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  removerVinculo(id: any, idPessoa: any) {
    return this.http.post<any>(this.baseUrl + '/mda/excluir-vinculo', {
      id: id,
      idPessoa: idPessoa
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  getByMda(id: string) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  desmarcar(idEncontro: any, idMda: any, motivo: any, desmarcadoPor: any) {
    return this.http.post<any>(this.baseUrl + '/mda/desmarcar-encontro', {
      idEncontro: idEncontro,
      idMda: idMda,
      motivo: motivo,
      desmarcadoPor: desmarcadoPor
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  remarcar(idEncontro: any, data: any, hora: any) {
    return this.http.post<any>(this.baseUrl + '/mda/remarcar-encontro', {
      idEncontro: idEncontro,
      data: data,
      hora
    }).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarMda(encontro: any) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-encontro',
      encontro
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }


  salvarHistorico(historico: any) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-historico',
      historico
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }


  ultimosEncontros(id: string) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id + '/encontros')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getHistoricos(id: string) {
    return this.http.get<any>(this.baseUrl + '/mda/' + id + '/historico')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  getEncontroTipo() {
    return this.http.get<any>(this.baseUrl + '/mda/get-encontro-tipo')
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

  salvarVinculo(mda: { horarioInicio: string; }) {
    mda.horarioInicio = mda.horarioInicio ?  mda.horarioInicio.replace(':', '') : '';
    return this.http.post<any>(this.baseUrl + '/mda/salvar-vinculo',
      mda
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

  salvarQualidadeDiscipulado(qualidade: any) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-avaliacao-discipulo',
      qualidade
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));

  }

  salvarReporte(reporte: any) {
    return this.http.post<any>(this.baseUrl + '/mda/salvar-reporte-discipulo',
      reporte
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));

  }


  solicitacao() {
    return this.http.post<any>(this.baseUrl + '/mda/solicitacao',
    {}
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));

  }

  confirmarEncontro(idEncontro: any) {
    return this.http.post<any>(this.baseUrl + '/mda/confirmar-encontro',
      { idEncontro: idEncontro }
    ).pipe(map(data => {
      if (!data.error) {
        return data;
      } else {
        return false;
      }
    }));
  }

}
